import React from "react";
import { motion } from "framer-motion";
import { EXPERIENCE as EXP } from "@/data/portfolio";
import { EXPERIENCE } from "@/constants/testIds";
import SectionHeading from "@/components/molecules/SectionHeading";

export default function Experience() {
  return (
    <section id="experience" data-testid={EXPERIENCE.section} className="section relative">
      <div className="container-x">
        <SectionHeading
          overline="03 — Experience"
          title="Where I've built & shipped."
          description="Two engineering chapters — both spent shipping enterprise frontends across multiple industries."
        />

        <div className="relative">
          <div className="absolute left-3 md:left-1/2 top-0 bottom-0 w-px bg-[color:var(--border)] md:-translate-x-px" />
          <div className="space-y-12 md:space-y-20">
            {EXP.map((job, idx) => {
              const right = idx % 2 === 1;
              return (
                <motion.div
                  key={job.id}
                  data-testid={EXPERIENCE.card(job.id)}
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-100px" }}
                  transition={{ duration: 0.7 }}
                  className={`relative grid md:grid-cols-2 gap-6 md:gap-12 ${right ? "" : ""}`}
                >
                  <div className="absolute left-3 md:left-1/2 top-6 w-3 h-3 -translate-x-1/2 rounded-full bg-[color:var(--accent)] ring-4 ring-[color:var(--bg)] z-10" />

                  {/* meta */}
                  <div className={`pl-8 md:pl-0 ${right ? "md:order-2 md:pl-12" : "md:text-right md:pr-12"}`}>
                    <div className="label-mono text-[color:var(--accent)] mb-2">{job.duration}</div>
                    <h3 className="font-display text-3xl md:text-4xl mb-2">{job.company}</h3>
                    <div className="text-[color:var(--text-muted)] font-mono text-sm">
                      {job.role} · {job.location}
                    </div>
                  </div>

                  {/* details */}
                  <div className={`pl-8 md:pl-0 ${right ? "md:order-1 md:pr-12 md:text-right" : "md:pl-12"}`}>
                    <div className="rounded-2xl border border-[color:var(--border)] bg-[color:var(--surface)] p-6 hover:border-[color:var(--accent)]/40 transition-colors">
                      <ul className="space-y-3 text-sm md:text-base text-[color:var(--text)]">
                        {job.bullets.map((b, i) => (
                          <li key={i} className="flex gap-2 text-left">
                            <span className="text-[color:var(--accent)] shrink-0">▸</span>
                            <span className="font-body text-[color:var(--text-muted)]">{b}</span>
                          </li>
                        ))}
                      </ul>
                      <div className="mt-5 flex flex-wrap gap-2">
                        {job.stack.map((t) => (
                          <span
                            key={t}
                            className="px-2.5 py-1 rounded-full bg-[color:var(--bg)] border border-[color:var(--border)] text-xs font-mono text-[color:var(--text-muted)]"
                          >
                            {t}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
